<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="contrato-expirado-modal-bloqueio"
      :class="{ 'contrato-expirado-modal-bloqueio--bloqueado': bloqueado }"
      role="dialog"
      aria-modal="true"
      @click.self="fecharSePermitido"
    >
      <div class="contrato-expirado-modal-bloqueio__content">
        <button
          type="button"
          class="contrato-expirado-modal-bloqueio__image-button"
          aria-label="Revisar e aceitar termo"
          @click="emit('assinar-contrato')"
        >
          <img
            src="@/ui/assets/images/contrato-expirado-bloqueio.png"
            alt="Atualizamos nossos Termos de Uso. Revise e aceite a nova versão."
            class="contrato-expirado-modal-bloqueio__image"
          />
        </button>
        <button
          v-if="!bloqueado"
          type="button"
          class="contrato-expirado-modal-bloqueio__close"
          aria-label="Fechar aviso de termo pendente"
          @click.stop="fecharSePermitido"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    bloqueado?: boolean;
  }>(),
  {
    bloqueado: false
  }
);

const emit = defineEmits<{
  "update:modelValue": [value: boolean];
  "assinar-contrato": [];
}>();

function fecharSePermitido() {
  if (props.bloqueado) {
    return;
  }

  emit("update:modelValue", false);
}

function handleKeydown(event: KeyboardEvent) {
  if (props.modelValue && props.bloqueado && isDevtoolsShortcut(event)) {
    event.preventDefault();
    event.stopPropagation();

    return;
  }

  if (event.key !== "Escape" || !props.modelValue) {
    return;
  }

  fecharSePermitido();
}

function isDevtoolsShortcut(event: KeyboardEvent) {
  const key = event.key.toLowerCase();

  return (
    event.key === "F12" ||
    (event.ctrlKey && event.shiftKey && ["i", "j", "c"].includes(key)) ||
    (event.ctrlKey && key === "u")
  );
}

function handleContextMenu(event: MouseEvent) {
  if (!props.modelValue || !props.bloqueado) {
    return;
  }

  event.preventDefault();
}

onMounted(() => {
  document.addEventListener("keydown", handleKeydown, true);
  document.addEventListener("contextmenu", handleContextMenu, true);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeydown, true);
  document.removeEventListener("contextmenu", handleContextMenu, true);
});
</script>

<style lang="scss">
@use "@/ui/styles/variables" as *;

.contrato-expirado-modal-bloqueio {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.48);
  box-sizing: border-box;
  font-family: $fontFamily;
  cursor: pointer;

  &--bloqueado {
    cursor: default;
  }

  &__content {
    position: relative;
    width: min(673px, calc(100vw - 48px));
  }

  &__image-button {
    display: block;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
  }

  &__image {
    display: block;
    width: 100%;
    object-fit: contain;
  }

  &__close {
    appearance: none;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 8px;
    border: 0;
    background: transparent;
    color: rgb(255, 255, 255);
    cursor: pointer;
    font-size: 25px;
    line-height: 8px;
  }
}
</style>
